<script setup lang="ts">
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { goalbookUrls } from '@/util/links'
import { FROM_HOME, HOME_EVENT_NAMES } from './event_names'

const analytics = getAnalyticsTracker()

function trackOpenGrow() {
  analytics.sendEvent(HOME_EVENT_NAMES.CLICKED_OPEN_GROW, FROM_HOME)
}
</script>

<template>
  <section class="flex flex-wrap items-center justify-center gap-[28px] border-2 border-[#BDBDBD] p-[26px]" aria-label="Grow">
    <img alt="Grow logo" src="@/assets/grow_logo.svg" class="h-[50px] w-auto">
    <p class="m-0 max-w-[520px] text-gray-900">Progress Monitor your IEP goals using Grow.</p>
    <a
      :href="goalbookUrls.grow"
      target="_blank"
      rel="noopener"
      class="flex items-center justify-center whitespace-nowrap rounded-[8px] border border-[#23537B] px-6 py-3 text-[15px] font-[600] text-[#23537B] no-underline hover:bg-[#EEEEEE] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#23537B]"
      @click="trackOpenGrow"
    >
      Open Grow
      <span class="sr-only">(opens in new tab)</span>
    </a>
  </section>
</template>
